import React from 'react'
import { __DEV__ } from '@mote/helpers/constants'
import { VisuallyHidden } from '../visuallyHidden/visuallyHidden'
import {
  CheckedDot,
  RadioButtonContainer,
  RadioButtonContent,
  RadioButtonLabel
} from './RadioButton.styles'
import type { UseRadioProps } from './useRadio'
import { useRadio } from './useRadio'

interface BaseProps extends UseRadioProps {
  label?: string
  labelPosition?: 'left' | 'right'
}

type NativeAttrs = Omit<React.InputHTMLAttributes<unknown>, keyof BaseProps>

export type RadioButtonProps = BaseProps & NativeAttrs

export const RadioButton = ({
  label,
  labelPosition = 'right',
  className,
  ...rest
}: RadioButtonProps) => {
  const hasLabel = Boolean(label)
  const radio = useRadio(rest)

  return (
    <RadioButtonContainer className={className} {...radio.getRootProps()}>
      {hasLabel && labelPosition === 'left' && (
        <RadioButtonLabel
          className='radiobutton-text'
          {...radio.getLabelProps()}
        >
          {label}
        </RadioButtonLabel>
      )}
      <RadioButtonContent
        className='radiobutton-container'
        {...radio.getRadioProps()}
      >
        <VisuallyHidden
          className='radiobutton-input'
          {...radio.getInputProps()}
        />
        <CheckedDot className='radiobutton-check' />
      </RadioButtonContent>
      {hasLabel && labelPosition === 'right' && (
        <RadioButtonLabel
          className='radiobutton-text'
          {...radio.getLabelProps()}
        >
          {label}
        </RadioButtonLabel>
      )}
    </RadioButtonContainer>
  )
}

if (__DEV__) {
  RadioButton.displayName = 'RadioButton'
}
